import React, { useState } from "react";
import "./vendorOffer.css";
import { FaCircleCheck } from "react-icons/fa6";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UseMediaQuery from "./../UseMediaQuery";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { MdPeople } from "react-icons/md";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { MdBusinessCenter } from "react-icons/md";
const VendorOffer = () => {
  const isMobile = UseMediaQuery("(max-width:768px)");
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const businessData = [
    {
      icon: <FaCircleCheck className="venderIcon" />,
      title: "Verified Leads",
      description:
        "Get verified leads sent to you on a real-time basis, tracked using the Mestry Circle partners app.",
    },
    {
      icon: <MdPeople className="venderIcon" />,
      title: "New Clients",
      description:
        "Interact with new clients connecting with your company, provide the best quote, and win.",
    },
    {
      icon: <MdBusinessCenter className="venderIcon" />,
      title: "Grow Your Business",
      description:
        "Reach more clients with bigger exposure through a dedicated profile for your business and pay only for matched leads.",
    },
  ];
  const NextArrow = ({ onClick }) => (
    <div
      className={`vendorArrow vendorNext ${isLastSlide ? "iconHidden" : ""}`}
      onClick={onClick}
    >
      <IoIosArrowForward />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className={`vendorArrow vendorPrev ${isFirstSlide ? "iconHidden" : ""}`}
      onClick={onClick}
    >
      <IoIosArrowBack />
    </div>
  );

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,

    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 486,
        settings: { slidesToShow: 1 },
      },
    ],
    beforeChange: (current, next) => {
      setIsFirstSlide(next === 0);
      setIsLastSlide(next === businessData.length - 1);
    },
  };

  return (
    <div className="container my-xl-5 my-lg-5 my-md-3 my-sm-2 my-2">
      <div className="row justify-content-center">
        <div className="col-12 my-3 ">
          <h3 className="abtMetsryh1">
            What does <span className="banHeading">Mestry Circle</span> offer
            you?
          </h3>
        </div>

        {isMobile ? (
          <Slider {...settings}>
            {businessData?.map((item, i) => (
              <div
                key={i}
                className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 d-flex justify-content-center p-1"
              >
                <div className="voffrer text-center p-4">
                  <div className="row d-flex justify-content-center">
                    {" "}
                    <div className="venderIconWidth col-12">
                      {" "}
                      <p className="venderIcon my-2">{item.icon}</p>
                    </div>
                  </div>

                  <h3 className="venderOfferh1 my-2">{item.title}</h3>
                  <p className="venderOfferP">{item.description}</p>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <>
            {businessData.map((item, i) => (
              <div
                key={i}
                className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 d-flex justify-content-center p-3"
              >
                <div className="voffrer text-center p-4">
                  <p className=" my-2">{item.icon}</p>
                  <h3 className="venderOfferh1 my-2">{item.title}</h3>
                  <p className="venderOfferP">{item.description}</p>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default VendorOffer;
